import { Component, Input, ViewChild } from '@angular/core';

import { IGenericField } from '../generic-field';

import { DateFieldComponent } from '../date-field/date-field.component';
import { FormBuilderService } from "libraries/service/formBuilder/formBuilder.service";

import { DateParserService } from 'libraries/service/date/dateParser.service';
import { Calendar2months } from "../calendar2months/calendar2months.component";

import { Yii } from "libraries/interfaces/Yii";
import { LanguageService } from "libraries/service/language/language.service";

/**
 * Date-field
 * Generate date field with calendar
 * @deprecated
 */
@Component({
    selector: 'date2months-field',
    templateUrl: './date2months-field.component.html',
    styleUrls: ['./date2months-field.component.scss'],
    styles: [`
      .relative {
        position: relative;
      }
    `]
})
export class Date2monthsFieldComponent extends DateFieldComponent implements IGenericField {
    @Input()
    public disabled: boolean = false;

    @Input()
    public isBeforeMinMessage: string = Yii.t('wui-shared-js',"La date est trop tôt.");

    @ViewChild('field')
    public fieldCalendar2months: Calendar2months;

    constructor(
        formBuilderService: FormBuilderService,
        dateParser: DateParserService,
        languageService: LanguageService,
    ) {
        super(formBuilderService, dateParser, languageService);
    }

    public onSelectDate($event: Event): void {
        this.selectDate.emit($event);
    }

    public openAndFocus(): void{
        this.fieldCalendar2months.openAndFocus();
    }

}

